<div kendoTooltip class="k-pb-2 k-pt-2">
    <kendo-chip *ngIf="complianceStatus === outOfCompliance" rounded="full" size="large" fillMode="solid"
        themeColor="warning" class="status-chip ooc-chip" [selected]="true"
        title="{{ daysPastCompliance }} Days Past Compliance Date" [label]="complianceStatus">
    </kendo-chip>
    <kendo-chip *ngIf="complianceStatus === atRisk" rounded="full" size="large" fillMode="solid" themeColor="warning"
        class="status-chip ar-chip" [selected]="true"
        title="{{ daysPastPolicyCompliance }} Days Past Policy Compliance Date" [label]="complianceStatus">
    </kendo-chip>
</div>